import { render, staticRenderFns } from "./distributionListAdd.vue?vue&type=template&id=d130bdda&scoped=true&"
import script from "./distributionListAdd.vue?vue&type=script&lang=js&"
export * from "./distributionListAdd.vue?vue&type=script&lang=js&"
import style0 from "./distributionListAdd.vue?vue&type=style&index=0&id=d130bdda&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d130bdda",
  null
  
)

export default component.exports